"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { "data-name": 'Layer 2' },
        React.createElement(Svg.G, { "data-name": 'download' },
            React.createElement(Svg.Rect, { width: '24', height: '24', opacity: '0' }),
            React.createElement(Svg.Rect, { x: '4', y: '18', width: '16', height: '2', rx: '1', ry: '1' }),
            React.createElement(Svg.Rect, { x: '3', y: '17', width: '4', height: '2', rx: '1', ry: '1', transform: 'rotate(-90 5 18)' }),
            React.createElement(Svg.Rect, { x: '17', y: '17', width: '4', height: '2', rx: '1', ry: '1', transform: 'rotate(-90 19 18)' }),
            React.createElement(Svg.Path, { d: 'M12 15a1 1 0 0 1-.58-.18l-4-2.82a1 1 0 0 1-.24-1.39 1 1 0 0 1 1.4-.24L12 12.76l3.4-2.56a1 1 0 0 1 1.2 1.6l-4 3a1 1 0 0 1-.6.2z' }),
            React.createElement(Svg.Path, { d: 'M12 13a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1z' })))));
//# sourceMappingURL=DownloadOutline.js.map